import React, { useContext, useEffect } from "react"
import { myContext } from "../context/Provider"

import { Container } from "../components/auvelity-ui"
import tw from "twin.macro"
import { showCookiePreference } from "../utils"

const footerLinks = [
  {
    text: "Contact Us",
    link: "https://www.axsome.com/contact-us",
    external: false,
    classForGTM: "gtm-navigation fl-exit-contact-us",
  },
  {
    text: "Privacy Notice",
    link: "https://www.axsome.com/privacy-notice",
    external: false,
    classForGTM: "gtm-navigation fl-exit-privacy",
  },
  {
    text: "Terms of Use",
    link: "https://www.axsome.com/terms-of-use",
    external: false,
    classForGTM: "gtm-navigation fl-exit-terms",
  },
  {
    text: "Do Not Sell My Personal Information",
    link: "",
    external: false,
    classForGTM: "ot-sdk-show-settings",
    id: "ot-sdk-button",
  },
]

const SpanishFooterCopy = () => (
  <>
    <p tw="mb-0">
      AUVELITY, AXSOME y sus logotipos son marcas comerciales o marcas
      registradas de Axsome Therapeutics, Inc. o sus filiales.
      <br />
      Otras marcas comerciales son propiedad de sus respectivos dueños
    </p>
    <p tw="mb-0">
      &copy; 2024 Axsome Therapeutics, Inc. Todos los derechos reservados.
      Destinado a residentes de EE. UU. mayores de 18&nbsp;años.
    </p>
    <p tw="mt-0">
      PP&#8209;AUV&#8209;US&#8209;2&zwj;3&zwj;0&zwj;0&zwj;1&zwj;7&zwj;4 03/2024
    </p>
  </>
)

const EnglishFooterCopy = () => (
  <>
    <p tw="mb-0">
      AUVELITY, AXSOME, and their logos are trademarks or registered trademarks of
      Axsome Therapeutics, Inc. or its affiliates. Other trademarks are property
      of their respective owners.
    </p>
    <p tw="mb-0">
      &copy; 2025 Axsome Therapeutics, Inc. All rights reserved. This&nbsp;site
      is intended for U.S. residents ages 18 and older.
    </p>
    <p tw="mt-0">
      PP-AUV-US-2100005 04/2025
    </p>
  </>
)

const pipeBase = tw`px-2 lg:px-4 text-yellow`

const Footer = () => {
  const context = useContext(myContext)
  useEffect(() => {
    const handleClick = () => {
      document
        .querySelectorAll(".onetrust-pc-dark-filter")
        .forEach(el => el.classList.add("show"))
  
      const banner = document.getElementById("onetrust-banner-sdk")
      if (banner) {
        banner.classList.add("show")
      }
    }
  
    const button = document.getElementById("ot-sdk-button")
    if (button) {
      button.addEventListener("click", handleClick)
    }
  
    return () => {
      if (button) {
        button.removeEventListener("click", handleClick)
      }
    }
  }, [])

  const handleCookieClick = () => {
    document
      .querySelectorAll(".onetrust-pc-dark-filter")
      .forEach(el => el.classList.add("show"))

    const banner = document.getElementById("onetrust-banner-sdk")
    if (banner) {
      banner.classList.add("show")
    }
  }

  return (
    <>
      <footer>
        <div tw="bg-darkgrey lg:py-16 pt-12 pb-8">
          <Container>
            <div tw="mb-10">
              <a
                href="https://axsome.com/"
                target="_blank"
                className="gtm-navigation fl-exit-axsome"
                data-gtm-location="footer logo"
                rel="noreferrer"
              >
                <img
                  src="/images/axsome-logo.svg"
                  tw="pointer-events-none lg:inline mr-6 mb-10 lg:mb-0 w-52 lg:w-64"
                  alt="Go to Axsome.com"
                  width="208"
                  height="28"
                />
              </a>
              <span tw="lg:inline-flex lg:w-2/3 w-full flex-wrap flex">
                {footerLinks.map((link, i, arr) => (
                  <React.Fragment key={`footer-link-${i}`}>
                    {link.link ? (
                      <a
                        target="_blank"
                        className={link.classForGTM}
                        href={link.link}
                        tw="py-2 text-white text-ms font-medium"
                        data-gtm-location="footer menu"
                        data-elementname={link.text}
                        rel="noreferrer"
                      >
                        {link.text}
                        <span
                          css={[
                            pipeBase,
                            i === arr.length - 1
                              ? tw`hidden`
                              : i === 1 && tw`inline`,
                          ]}
                        >
                          |
                        </span>
                      </a>
                    ) : (
                      <button
                        id={link.id}
                        className={link.classForGTM}
                        tw="text-white text-ms font-medium"
                        onClick={handleCookieClick}
                      >
                        {link.text}
                      </button>
                    )}
                  </React.Fragment>
                ))}
              </span>
            </div>
            <div tw="w-1/2 flex justify-between"></div>
          </Container>
          <Container>
            <div tw="text-white text-xs lg:(text-[14px])">
              {context.activeSpanishPage ? (
                <SpanishFooterCopy />
              ) : (
                <EnglishFooterCopy />
              )}
            </div>
          </Container>
        </div>
      </footer>
      <script type="text/javascript" defer src="https://extend.vimeocdn.com/ga4/72804855.js"></script>
    </>
  )
}

export default Footer
